import {classNames} from "primereact/utils";
import {ProgressBar} from "primereact/progressbar";
import {Badge} from "primereact/badge";
import React, {useCallback, useEffect, useState} from "react";
import {Button} from "primereact/button";
import {getTempUrl, uploadTempUrl} from "../../../../redux/api/apiMonitoringList";
import AudioPlayer from "../../AudioPlayer";
import {useAppDispatch, useAppSelector} from "../../../../redux/hooks";
import {checkPermissions} from "../../../../redux/permissions/permissionsUtils";
import {changeRecallNumber, setRecallNumber, setSpySessionId} from "../../../../redux/actions/actionsWebRTC";
import {getGroupSessionId} from "../../../../utils/callSessionUtils";
import {Divider} from "primereact/divider";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Dialog} from "primereact/dialog";
import {SET_USER_STATUS_SUCCESS} from "../../../../redux/types/typesUsersList";
import {Dropdown} from "primereact/dropdown";
import {Skeleton} from "primereact/skeleton";
import {setIsSpeacking} from "../../../../redux/actions/actionsMonitoringList";
import {checkSessionForSpy} from "../../../../redux/api/api";

const MonitoringListDetails = (props: any) => {
    const dispatch = useAppDispatch();
    const monitoringData = useAppSelector(state => state.MonitoringListReducer?.monitoringData);
    const statusDictionary = useAppSelector(state => state.MonitoringListReducer.statusDictionary);
    const detailsLoading = useAppSelector(state => state.MonitoringListReducer.detailsLoading);
    const rolesVision = useAppSelector(state => state.RolesReducer.rolesVision) as any;
    const playerPermissions = checkPermissions(rolesVision, 'Player');
    const audioUrl = useAppSelector(state => state.MonitoringListReducer.audioUrl);
    const audioUrlLoading = useAppSelector(state => state.MonitoringListReducer.audioUrlLoading);
    const audioUrlUploadLoading = useAppSelector(state => state.MonitoringListReducer.audioUrlUploadLoading);
    const recallNumberChanged = useAppSelector(state => state.WebRTCReducer.recallNumberChanged);
    const sipUserBusy = useAppSelector(state => state.WebRTCReducer.sipUserBusy);
    const [timeStamp, setTimeStamp] = useState<any>(null);
    const jwtToken = useAppSelector(state => state.UsersReducer.userData.jwtToken);
    const [visible, setVisible] = useState(false);
    const callResetDictionary = useAppSelector(state => state.MonitoringListReducer.callResetDictionary);
    const forcedClosingDictionary = useAppSelector(state => state.MonitoringListReducer.forcedClosingDictionary);
    // @ts-ignore
    const isSpeakingAudio = useAppSelector(state => state.MonitoringListReducer.isSpeakingAudio);
    const ownerTypeDictionary = useAppSelector(state => state.MonitoringListReducer.ownerTypeDictionary);
    const [loader, setLoader] = useState(false);
    const [selectedSpyCallType, setSelectedSpyCallType] = useState("none");
    const [spyListenRequestPending, setSpyListenRequestPending] = useState(false);
    const user = useAppSelector(state => state.UsersReducer.userData);
    const [validAudioUrl, setValidAudioUrl] = useState<any[]>([]);
    const audioOptions = [
        ...(validAudioUrl?.some(item => item.audioType === 1)
            ? [{name: 'Запис розмови', code: 1}]
            : []),
        ...(validAudioUrl?.some(item => item.audioType === 2)
            ? [{name: 'Запис дзвінка', code: 2}]
            : []),
    ];
    const hasAudioType1 = validAudioUrl?.some((item: { audioType: number; }) => item?.audioType === 1);
    const hasAudioType2 = validAudioUrl?.some((item: { audioType: number; }) => item?.audioType === 2);
    const isDropdownEnabled = hasAudioType1 && hasAudioType2;
    const spyPermissions = checkPermissions(rolesVision, 'SpyCall');
    const {
        visible: hasSpyVisionPermission
    } = spyPermissions;


    useEffect(() => {
        dispatch({type: SET_USER_STATUS_SUCCESS, payload: null});
    }, []);

    useEffect(() => {
        if (!validAudioUrl || validAudioUrl.length === 0) {
            dispatch(setIsSpeacking(null));
            return;
        }

        const hasAudioType1 = validAudioUrl.some((item: { audioType: number; }) => item.audioType === 1);
        const hasAudioType2 = validAudioUrl.some((item: { audioType: number; }) => item.audioType === 2);

        if (hasAudioType1) {
            dispatch(setIsSpeacking({name: 'Запис розмови', code: 1}));
        } else if (hasAudioType2) {
            dispatch(setIsSpeacking({name: 'Запис дзвінка', code: 2}));
        } else {
            dispatch(setIsSpeacking(null));
        }
    }, [validAudioUrl]);

    useEffect(() => {
        if (!audioUrl || audioUrl.length === 0) {
            setValidAudioUrl([]);
            return;
        }

        const audioElements = audioUrl.map((url: any) =>
            new Promise((resolve) => {
                const audio = new Audio();
                audio.src = url.tempUrl;

                audio.onloadedmetadata = () => {
                    if (audio.duration >= 0.6) {
                        resolve(url);
                    } else {
                        resolve(null);
                    }
                };

                audio.onerror = () => resolve(null);
            })
        );

        Promise.all(audioElements).then((results) => {
            const filtered = results.filter(Boolean);
            setValidAudioUrl(filtered as any[]);
        });
    }, [audioUrl]);

    const {
        visible: hasPlayerVisiblePermission,
        update: hasPlayerUpdatePermission,
    } = playerPermissions;

    let foundStatus = statusDictionary?.filter((status: any) => status?.dictionaryId === monitoringData?.status);
    let foundOwnerType = ownerTypeDictionary?.filter((status: any) => status?.dictionaryId === monitoringData?.ownerType);

    const statusClass = classNames({
        'p-badge status-active': foundStatus?.[0]?.dictionaryId === 101,
        'p-badge status-success': foundStatus?.[0]?.dictionaryId === 103,
        'p-badge status-unsuccessful': foundStatus?.[0]?.dictionaryId === 104,
        'p-badge status-action': foundStatus?.[0]?.dictionaryId === 'ACTION',
        'p-badge status-processing': foundStatus?.[0]?.dictionaryId === 102
    });

    const handlePlay = useCallback(() => {
        setTimeStamp(null);
        dispatch(getTempUrl(jwtToken?.jwtToken, monitoringData?.sessionId, monitoringData?.id));
    }, [dispatch, jwtToken?.jwtToken, monitoringData?.sessionId, monitoringData?.id]);

    const checkBanUser = () => {
        let data = {
            nameTo: monitoringData?.ani || monitoringData?.aNI,
            sessionId: getGroupSessionId(monitoringData),
        }
        dispatch(setRecallNumber(data));
        dispatch(changeRecallNumber(!recallNumberChanged));
        if (windowWidth <= 1248) {
            props.setSelectedRowData(null);
            props.setSelectedRowExpansion(null);
        }
    }

    const checkSpySession = async (spyType?: "spy" | "listen" | "talk") => {
        if (spyListenRequestPending) {
            return;
        }
        setSpyListenRequestPending(true);
        try {
            const selectedType = spyType || selectedSpyCallType;
            setSelectedSpyCallType(selectedType);
            dispatch(setSpySessionId(monitoringData?.sessionId || monitoringData?.groupSessionId || null));
            let data = {
                userName: user?.userName,
                sessionId: monitoringData?.sessionId || monitoringData?.groupSessionId,
                type: selectedType
            };
            const ok = await dispatch(checkSessionForSpy(data, jwtToken?.jwtToken) as any);
            if (ok !== true) {
                dispatch(setSpySessionId(null));
            }
        } finally {
            setSpyListenRequestPending(false);
        }
    }

    const audioHeaderBody = () => {
        return <div>Запис дзвінка</div>
    }

    const copyAudio = (audioUrl: any) => {
        const audioType1 = audioUrl?.filter((item: { audioType: number; }) => item?.audioType === 1);
        const audioType2 = audioUrl?.filter((item: { audioType: number; }) => item?.audioType === 2);
        const src = isSpeakingAudio?.code === 1
            ? audioType1?.[0]?.tempUrl
            : isSpeakingAudio?.code === 2
                ? audioType2?.[0]?.tempUrl
                : null;
        const copyToClipboard = (text: string) => {
            const tempElement = document.createElement('textarea');
            tempElement.value = text;
            document.body.appendChild(tempElement);
            tempElement.select();
            document.execCommand('copy');
            document.body.removeChild(tempElement);
        }
        copyToClipboard(src);
        dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: 'Посилання аудіо скопійована в буфер обміну'}});
    }

    const audioBodyTemplate = () => {
        return hasPlayerVisiblePermission ? <>{(
            <div className="field col-12 md:col-12 flex align-items-center mb-0">
                <Button icon="pi pi-caret-right" disabled={monitoringData?.status === 101 || monitoringData?.status === 102} loading={audioUrlLoading} onClick={() => {
                    handlePlay();
                    setVisible(true);
                }} className="bg-primary" label="Прослухати"/>
            </div>)}
            {audioUrl && <Dialog header={audioHeaderBody} visible={visible} style={{width: '25vw'}} className="pb-0 audio-dialog" onHide={() => setVisible(false)}>
                <Dropdown disabled={loader || !isDropdownEnabled} filter value={isSpeakingAudio} onChange={(e) => dispatch(setIsSpeacking(e.value))} options={audioOptions} optionLabel="name"
                          className="w-full mt-2 mb-3"/>
                <div
                    className={`field col-12 md:col-12 flex flex-column align-items-center relative absolute outline-none border-none shadow-none border-circle save-mp3 text-lg mt-3 m-0 px-0 ${(!audioUrl || loader) && 'opacity-40'}`}
                >
                    <div className="w-full relative">
                        <div className="relative">
                            <AudioPlayer audioUrl={validAudioUrl} handleResetPlayer={props.handleResetPlayer} timeStamp={timeStamp} setTimeStamp={setTimeStamp}/>

                            {loader && (
                                <>
                                    <div className="absolute left-0 right-0 top-0 bottom-0 inset-0 flex justify-center items-center bg-opacity-50 z-100000">
                                        <Skeleton width="100%" height="100%" className="absolute inset-0"/>
                                    </div>
                                    <ProgressBar className="absolute top-0 w-full" mode="indeterminate" style={{height: '3px'}}></ProgressBar>
                                </>
                            )}
                        </div>
                        {hasPlayerUpdatePermission && (
                            <Button
                                onClick={() => dispatch(uploadTempUrl(jwtToken?.jwtToken, monitoringData?.sessionId, monitoringData?.id, isSpeakingAudio))}
                                disabled={!validAudioUrl || loader}
                                icon="pi pi-download"
                                loading={audioUrlUploadLoading}
                                style={{marginLeft: '10px', top: '44px'}}
                                className={`absolute outline-none border-none shadow-none border-circle save-mp3 text-lg ${audioUrl ? 'opacity-100' : 'opacity-50'}`}
                            />
                        )}
                        {hasPlayerVisiblePermission && (
                            <Button
                                onClick={() => copyAudio(validAudioUrl)}
                                disabled={!validAudioUrl || loader}
                                icon="pi pi-copy"
                                style={{marginLeft: '10px', top: '44px'}}
                                className={`absolute outline-none border-none shadow-none border-circle save-mp3 text-lg ml-6 ${validAudioUrl ? 'opacity-100' : 'opacity-50'}`}
                            />
                        )}
                    </div>
                </div>
            </Dialog>}
        </> : ''
    }

    const formatDateTime = (dateTimeStr: string): string => {
        const date = new Date(dateTimeStr);

        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear().toString();

        return `${hours}:${minutes}:${seconds} ${day}/${month}/${year}`;
    };

    // const convertMillisecondsToTime = (totalMilliseconds: number): string => {
    //     const hours = Math.floor(totalMilliseconds / (1000 * 60 * 60));
    //     const minutes = Math.floor((totalMilliseconds % (1000 * 60 * 60)) / (1000 * 60));
    //     const seconds = Math.floor((totalMilliseconds % (1000 * 60)) / 1000);
    //
    //     return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    // };

    const convertSecondsToTime = (totalSeconds: number): string => {
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = Math.floor(totalSeconds % 60);

        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };
    const foundCallReset = callResetDictionary?.filter((item: any) => item?.dictionaryId === monitoringData?.callReset);
    const foundAmdHangup = forcedClosingDictionary?.filter((item: any) => item?.dictionaryId === monitoringData?.forcedClosing);

    const fields = [
        {label: "Оператор", value: monitoringData.fullName || '- - -'},
        ...(monitoringData?.campaignName || monitoringData?.queueName ? [{label: monitoringData?.campaignName ? 'Кампанія' : 'Черга', value: monitoringData.campaignName || monitoringData.queueName}] : []),
        ...(monitoringData?.campaignId || monitoringData?.queueId ? [{label: monitoringData?.campaignId ? 'ID кампанії' : 'ID Черги', value: monitoringData.campaignId || monitoringData.queueId}] : []),
        {label: "Транк", value: monitoringData?.aNumber || '- - -'},
        {label: "Тривалість дзвінка", value: monitoringData.fullCallDuration && monitoringData?.fullCallDuration !== -1 ? convertSecondsToTime(monitoringData.fullCallDuration) : monitoringData.fullCallDuration === 0 ? '00:00:00' : '- - -'},
        {label: "Тривалість розмови", value: monitoringData.duration && monitoringData.duration !== -1 ? convertSecondsToTime(monitoringData.duration) : monitoringData.duration === 0 ? '00:00:00' : '- - -'},
        {label: "Реакція Клієнта", value: monitoringData.reactionClient && monitoringData.reactionClient !== -1 ? convertSecondsToTime(monitoringData.reactionClient) : monitoringData.reactionClient === 0 ? '00:00:00' : '- - -'},
        {label: "Реакція Оператора", value: monitoringData.reactionOperator && monitoringData.reactionOperator !== -1 ? convertSecondsToTime(monitoringData.reactionOperator) : monitoringData.reactionOperator === 0 ? '00:00:00' : '- - -'},
        {label: "Завершив", value: foundCallReset?.[0]?.name || '- - -'},
        {label: "Причина завершення", value: foundAmdHangup?.[0]?.name || '- - -'},
        {label: "Початок", value: monitoringData.start ? formatDateTime(monitoringData.start) : '- - -'},
        {label: "Завершення", value: monitoringData.end ? formatDateTime(monitoringData.end) : '- - -'}
    ];

    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const copyDetailsLink = () => {
        let href = window.location.origin + '#/call_details/' + monitoringData?.id
        const copyToClipboard = (text: string) => {
            const tempElement = document.createElement('textarea');
            tempElement.value = text;
            document.body.appendChild(tempElement);
            tempElement.select();
            document.execCommand('copy');
            document.body.removeChild(tempElement);
        }
        copyToClipboard(href);
        dispatch({type: SET_USER_STATUS_SUCCESS, payload: {message: 'Посилання скопійована в буфер обміну'}});
    }

    const openDetailsLink = () => {
        let href = window.location.origin + '#/call_details/' + monitoringData?.id + '?childWindow=1'
        window.open(href, '_blank')
    }

    const canSpy = monitoringData?.status === 101;
    const spyHeadphonesDisabled = !canSpy || sipUserBusy || spyListenRequestPending;

    return (
        <div className="relative">
            {detailsLoading && <ProgressBar mode="indeterminate" style={{height: '6px'}}></ProgressBar>}
            <div className={classNames('grid', {'opacity-50': detailsLoading})}
                 style={{paddingTop: "0.3rem", padding: '0.3rem 10px 5px'}}>
                {windowWidth > 1248 &&
                    <div className="grid col-12 md:col-12 mb-0 px-0 w-full justify-content-between">
                        <div className="absolute top-0 right-0 flex">
                            <button className="close-button block cursor-pointer ml-auto mr-2"
                                    onClick={() => {
                                        copyDetailsLink();
                                    }
                                    }><span className="pi pi-copy"></span>
                            </button>
                            {!props.isWindow && <button className="close-button block cursor-pointer ml-auto mr-2"
                                                        onClick={() => {
                                                            openDetailsLink();
                                                        }
                                                        }><span className="pi pi-arrow-up-right-and-arrow-down-left-from-center"></span>
                            </button>}
                            {!props.isWindow && <button className="close-button block cursor-pointer ml-auto"
                                                        onClick={() => {
                                                            props.setSelectedRowData(null);
                                                            props.setSelectedRowExpansion(null);
                                                        }
                                                        }><span className="pi pi-times"></span>
                            </button>}
                        </div>
                        <div className="field col-12 md:col-5 flex align-items-start m-0">
                            <div className="field col-12 md:col-5 flex m-0 py-0 flex-column">
                                {monitoringData.pathSegment ?
                                    <a target="_blank" className="mb-2" href={`${monitoringData.pathSegment}?sessionId=${monitoringData?.sessionId}`}>{monitoringData.contactName}</a> :
                                    <p className="m-0 mb-2">{monitoringData.contactName}</p>}
                                <div className="flex align-items-center">
                                    <div className="mr-2">{monitoringData?.ani || monitoringData?.aNI}</div>
                                </div>
                            </div>
                            <div className="field col-12 md:col-7 flex flex m-0 py-0">
                                <Button icon="pi pi-phone" className="status-success border-none max-w-9rem mr-2" style={{borderRadius: '6px'}} onClick={() => {
                                    checkBanUser();
                                }}></Button>
                                {hasSpyVisionPermission && <Button disabled={spyHeadphonesDisabled} loading={spyListenRequestPending} icon="pi pi-headphones" className="status-success border-none max-w-9rem mr-2" style={{background: 'rgb(253, 166, 16)'}} onClick={() => {
                                    checkSpySession("spy");
                                }}></Button>}
                            </div>
                        </div>
                        <div className="field col-12 md:col-5 flex align-items-center justify-content-end m-0 pr-4">
                            <div className="field col-12 md:col-12 flex align-items-center m-0 p-0">
                                <div className="field col-6 md:col-7 flex align-items-center justify-content-end mb-0">
                                    {
                                        monitoringData?.callType === 'transferInternal' && !monitoringData.isDeclined ? (
                                            <div className="relative">
                                                <i className="pi pi-reply p-2 bg-green-500 border-circle text-white" style={{transform: 'rotate(90deg) scaleX(1) scaleY(-1)'}}></i>
                                            </div>
                                        ) : monitoringData?.callType === 'transferInternal' && monitoringData.isDeclined ? (
                                                <div className="relative">
                                                    <i className="pi pi-reply p-2 bg-green-500 border-circle text-white" style={{transform: 'rotate(90deg) scaleX(1) scaleY(-1)'}}></i>
                                                    <div className="absolute" style={{top: '-5px', left: '18px'}}>
                                                        <div className="border-circle relative"
                                                             style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                                            <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                                               style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                                                        </div>
                                                    </div>
                                                </div>) :

                                            monitoringData?.callType === 'transferExternal' && !monitoringData.isDeclined ? (
                                                <div className="relative">
                                                    <i className="pi pi-reply p-2 bg-primary border-circle text-white" style={{transform: 'rotate(90deg) scaleX(-1) scaleY(-1)'}}></i>
                                                </div>
                                            ) : monitoringData?.callType === 'transferInternal' && monitoringData.isDeclined ? (
                                                    <div className="relative">
                                                        <i className="pi pi-reply p-2 bg-primary border-circle text-white" style={{transform: 'rotate(90deg) scaleX(-1) scaleY(-1)'}}></i>
                                                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                                                            <div className="border-circle relative"
                                                                 style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                                                <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                                                            </div>
                                                        </div>
                                                    </div>) :

                                                monitoringData.callType === 'callback' ? (
                                                    <div className="relative">
                                                        <i className="pi pi-undo p-2 border-circle text-white" style={{backgroundColor: "#fda610"}}></i>
                                                    </div>
                                                ) : monitoringData?.callType === 'callbackExternal' && !monitoringData.isDeclined ? (
                                                    <div className="relative">
                                                        <i className="pi pi-undo p-2 border-circle text-white"
                                                           style={{background: 'rgb(253, 166, 16)'}}></i>
                                                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                                                            <div className="border-circle relative bg-primary"
                                                                 style={{width: '14px', height: '14px'}}>
                                                                <i className="pi pi-arrow-up-right text-white absolute left-50 top-50 kk"
                                                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                                                            </div>
                                                        </div>
                                                    </div>) : monitoringData?.callType === 'callbackInternal' && !monitoringData.isDeclined ? (
                                                    <div className="relative">
                                                        <i className="pi pi-undo p-2 border-circle text-white"
                                                           style={{background: 'rgb(253, 166, 16)'}}></i>
                                                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                                                            <div className="border-circle relative bg-green-500"
                                                                 style={{width: '14px', height: '14px'}}>
                                                                <i className="pi pi-arrow-down-left text-white absolute left-50 top-50 kk"
                                                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                                                            </div>
                                                        </div>
                                                    </div>) : (monitoringData?.callType === 'callbackInternal' || monitoringData?.callType === 'callbackExternal') && monitoringData.isDeclined ? (
                                                    <div className="relative">
                                                        <i className="pi pi-undo p-2 border-circle text-white"
                                                           style={{background: 'rgb(253, 166, 16)'}}></i>
                                                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                                                            <div className="border-circle relative"
                                                                 style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                                                <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                                                            </div>
                                                        </div>
                                                    </div>) : monitoringData.callType === 'internal' && !monitoringData.isDeclined ? (
                                                    <div className="relative">
                                                        <i className="pi pi-arrow-down-left p-2 border-circle bg-green-500 text-white"></i>
                                                    </div>
                                                ) : monitoringData.callType === 'internal' && monitoringData.isDeclined ? (
                                                    <div className="relative">
                                                        <i className="pi pi-arrow-down-left p-2 border-circle bg-green-500 text-white"></i>
                                                        <div className="absolute" style={{top: '-5px', left: '18px'}}>
                                                            <div className="border-circle relative"
                                                                 style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                                                <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                                                   style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                                                            </div>
                                                        </div>
                                                    </div>) : monitoringData?.callType === 'external' && !monitoringData.isDeclined ? (
                                                    <>
                                                        <i className="pi pi-arrow-up-right bg-primary p-2 border-circle text-white"></i>
                                                    </>
                                                ) : monitoringData?.callType === 'external' && monitoringData.isDeclined ? (
                                                        <div className="relative">
                                                            <i className="pi pi-arrow-up-right bg-primary p-2 border-circle text-white"></i>
                                                            <div className="absolute" style={{top: '-5px', left: '18px'}}>
                                                                <div className="border-circle relative"
                                                                     style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                                                    <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                                                       style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                                                                </div>
                                                            </div>
                                                        </div>)
                                                    : monitoringData?.callType === 'ivm' && !monitoringData.isDeclined ? (
                                                        <>
                                                            <i className="bg-primary p-2 border-circle text-white font-bold relative"
                                                               style={{fontStyle: "normal", width: '27.99px', height: '27.99px'}}><span
                                                                className="absolute"
                                                                style={{left: '50%', top: '50%', transform: 'translate(-50%, -50%)', fontSize: '11px'}}>IVM</span></i>
                                                        </>
                                                    ) : monitoringData?.callType === 'ivm' && monitoringData.isDeclined ? (
                                                        <div className="relative inline-block">
                                                            <i className="bg-primary border-circle text-white font-bold relative inline-flex align-items-center justify-content-center"
                                                               style={{fontStyle: "normal", width: '28px', height: '28px', minWidth: '28px', minHeight: '28px', borderRadius: '50%'}}><span
                                                                style={{fontSize: '11px'}}>IVM</span></i>
                                                            <div className="absolute" style={{top: '-3px', right: '-3px'}}>
                                                                <div className="border-circle relative"
                                                                     style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                                                    <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                                                       style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : monitoringData?.callType === 'ivr' && !monitoringData.isDeclined ? (
                                                        <>
                                                            <i className="bg-green-500 p-2 border-circle text-white font-bold relative"
                                                               style={{fontStyle: "normal", width: '27.99px', height: '27.99px'}}><span
                                                                className="absolute"
                                                                style={{left: '50%', top: '50%', transform: 'translate(-50%, -50%)', fontSize: '11px'}}>IVR</span></i>
                                                        </>
                                                    ) : monitoringData?.callType === 'ivr' && monitoringData.isDeclined ? (
                                                        <div className="relative inline-block">
                                                            <i className="bg-green-500 border-circle text-white font-bold relative inline-flex align-items-center justify-content-center"
                                                               style={{fontStyle: "normal", width: '28px', height: '28px', minWidth: '28px', minHeight: '28px', borderRadius: '50%'}}><span
                                                                style={{fontSize: '11px'}}>IVR</span></i>
                                                            <div className="absolute" style={{top: '-3px', right: '-3px'}}>
                                                                <div className="border-circle relative"
                                                                     style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                                                    <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                                                       style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : monitoringData?.callType === 'consultation' && !monitoringData.isDeclined ? (
                                                        <div className="relative">
                                                            <i className="pi pi-users p-2 border-circle text-white" style={{background: 'rgb(253, 166, 16)'}}></i>
                                                        </div>
                                                    ) : monitoringData?.callType === 'consultation' && monitoringData.isDeclined ? (
                                                        <div className="relative">
                                                            <i className="pi pi-users p-2 border-circle text-white"
                                                               style={{background: 'rgb(253, 166, 16)'}}></i>
                                                            <div className="absolute" style={{top: '-5px', left: '18px'}}>
                                                                <div className="border-circle relative"
                                                                     style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                                                    <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                                                       style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                                                                </div>
                                                            </div>
                                                        </div>) : monitoringData?.callType === 'consultationExternal' && !monitoringData.isDeclined ? (
                                                        <div className="relative">
                                                            <i className="pi pi-users p-2 border-circle text-white"
                                                               style={{background: 'rgb(253, 166, 16)'}}></i>
                                                            <div className="absolute" style={{top: '-5px', left: '18px'}}>
                                                                <div className="border-circle relative bg-primary"
                                                                     style={{width: '14px', height: '14px'}}>
                                                                    <i className="pi pi-arrow-up-right text-white absolute left-50 top-50 kk"
                                                                       style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : monitoringData?.callType === 'consultationInternal' && !monitoringData.isDeclined ? (
                                                        <div className="relative">
                                                            <i className="pi pi-users p-2 border-circle text-white"
                                                               style={{background: 'rgb(253, 166, 16)'}}></i>
                                                            <div className="absolute" style={{top: '-5px', left: '18px'}}>
                                                                <div className="border-circle relative bg-green-500"
                                                                     style={{width: '14px', height: '14px'}}>
                                                                    <i className="pi pi-arrow-down-left text-white absolute left-50 top-50 kk"
                                                                       style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : (monitoringData?.callType === 'consultationInternal' || monitoringData?.callType === 'consultationExternal') && monitoringData.isDeclined ? (
                                                        <div className="relative">
                                                            <i className="pi pi-users p-2 border-circle text-white"
                                                               style={{background: 'rgb(253, 166, 16)'}}></i>
                                                            <div className="absolute" style={{top: '-5px', left: '18px'}}>
                                                                <div className="border-circle relative"
                                                                     style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                                                    <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                                                       style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                                                                </div>
                                                            </div>
                                                        </div>) : (monitoringData?.callType === 'pickupcall') && monitoringData.isDeclined ? (
                                                        <div className="relative">
                                                            <i className="pi pi-user p-2 border-circle text-white"
                                                               style={{background: 'rgb(253, 166, 16)'}}></i>
                                                            <div className="absolute" style={{top: '-5px', left: '18px'}}>
                                                                <div className="border-circle relative"
                                                                     style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                                                    <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                                                       style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                                                                </div>
                                                            </div>
                                                        </div>) : monitoringData?.callType === 'pickupcall' && !monitoringData.isDeclined ? (
                                                            <div className="relative">
                                                                <i className="pi pi-user p-2 border-circle text-white" style={{background: 'rgb(253, 166, 16)'}}></i>
                                                            </div>) : (monitoringData?.callType === 'spycall') && monitoringData.isDeclined ? (
                                                            <div className="relative">
                                                                <i className="pi pi-headphones p-2 border-circle text-white"
                                                                   style={{background: 'rgb(253, 166, 16)'}}></i>
                                                                <div className="absolute" style={{top: '-5px', left: '18px'}}>
                                                                    <div className="border-circle relative"
                                                                         style={{backgroundColor: 'red', width: '14px', height: '14px'}}>
                                                                        <i className="pi pi-times text-white absolute left-50 top-50 kk"
                                                                           style={{fontSize: '10px', transform: 'translate(-50%, -50%)'}}></i>
                                                                    </div>
                                                                </div>
                                                            </div>) : monitoringData?.callType === 'spycall' && !monitoringData.isDeclined ? (
                                                            <div className="relative">
                                                                <i className="pi pi-headphones p-2 border-circle text-white" style={{background: 'rgb(253, 166, 16)'}}></i>
                                                            </div>) :
                                                        <div className="relative">
                                                            <i className="pi pi-arrow-down-left p-2 border-circle bg-green-500 text-white"></i>
                                                        </div>
                                    }
                                    <div className="ml-2 font-bold">
                                        {monitoringData.direction}
                                    </div>
                                </div>
                                <div className="field col-6 md:col-3 flex align-items-center mb-0 py-0 pr-4">
                                    <Badge value={foundStatus?.[0]?.name}
                                           className={`${statusClass} text-white customer-badge text-xs mx-auto p-0`}
                                           style={{borderRadius: '6px', maxWidth: '95px', minWidth: '95px'}}/>
                                </div>
                            </div>

                        </div>
                        <Divider className="m-0 ml-2"/>
                        <div className="field col-12 md:col-9 flex align-items-center m-0 py-0 flex-wrap">
                            <div className="field col-12 md:col-2 flex align-items-center m-0">
                                <p>Власник дзвінка</p>
                            </div>
                            <div className="field col-12 md:col-4 flex align-items-center m-0" style={{borderRight: `1px solid rgba(255, 255, 255, 0.15)`}}>
                                <p>{monitoringData.ownerUserName || '- - -'}</p>
                            </div>
                            <div className="field col-12 md:col-2 flex m-0">
                                <p>Оператор</p>
                            </div>
                            <div className="field col-12 md:col-4 flex align-items-center m-0">
                                <p>{monitoringData.fullName || '- - -'}</p>
                            </div>
                            <div className="field col-12 md:col-2 flex m-0">
                                <p>Тип власника</p>
                            </div>
                            <div className="field col-12 md:col-4 flex align-items-center m-0" style={{borderRight: `1px solid rgba(255, 255, 255, 0.15)`}}>
                                <p>{foundOwnerType?.[0]?.description || '- - -'}</p>
                            </div>

                            <div className="field col-12 md:col-2 flex m-0">
                                <p>Транк</p>
                            </div>
                            <div className="field col-12 md:col-4 flex m-0">
                                <p>{monitoringData.aNumber || '- - -'}</p>
                            </div>
                            {/*<div className="field col-12 md:col-6 flex m-0" style={{borderRight: `1px solid rgba(255, 255, 255, 0.15)`}}>*/}
                            {/*</div>*/}
                            <div className="field col-12 md:col-2 flex align-items-center m-0">
                            </div>
                            <div className="field col-12 md:col-4 flex align-items-center m-0">
                            </div>
                            <div className="field col-12 md:col-2 flex align-items-center m-0" style={{borderLeft: `1px solid rgba(255, 255, 255, 0.15)`}}>
                                {monitoringData?.campaignId ? <p>ID / Назва Кампанii</p> : monitoringData?.queueId ? <p>ID / Назва Черги</p> : <></>}
                            </div>
                            <div className="field col-12 md:col-4 flex align-items-center m-0">
                                {monitoringData?.campaignId ?
                                    <p>{monitoringData?.campaignId} {monitoringData?.campaignName}</p> :
                                    monitoringData?.queueId ? <p>{monitoringData?.queueId} {monitoringData?.queueName}</p> :
                                        <></>
                                }
                            </div>
                        </div>
                        <div className="field col-12 md:col-3 flex m-0 py-0" style={{borderLeft: `1px solid rgba(255, 255, 255, 0.15)`}}>
                            <div className="field col-12 md:col-4 flex m-0">
                                <p>Опис</p>
                            </div>
                            <div className="field col-4 md:col-8 flex m-0">
                                <p>{monitoringData.description || '- - -'}</p>
                            </div>
                        </div>
                        <Divider className="m-0 ml-2"/>
                    </div>
                }
                {windowWidth <= 1248 && (monitoringData.contactName || monitoringData.pathSegment) &&
                    <div className="grid col-12 md:col-12 mb-0 px-0">
                        <div className="field col-12 md:col-12 flex align-items-center m-0">
                            {monitoringData.pathSegment ?
                                <a target="_blank" className="mb-2" href={`${monitoringData.pathSegment}?sessionId=${monitoringData?.sessionId}`}>{monitoringData.contactName}</a> :
                                <p className="m-0 mb-2">{monitoringData.contactName}</p>}
                        </div>
                        {(monitoringData.contactName || monitoringData.pathSegment) && (
                            <div className="field col-12 md:col-12 p-0"
                                 style={{margin: 0, borderBottom: '1px solid #cccccc38'}}></div>)}
                    </div>}
                {windowWidth > 1248 && <React.Fragment>
                    <DataTable scrollable={windowWidth < 1400} className="col-12 md:col-12 pl-0 py-0" value={[monitoringData]}
                    >
                        <Column
                            header={'Тривалість дзвінка'}
                            className="justify-content-start"
                            body={(data) => data.fullCallDuration && data?.fullCallDuration !== -1 ? convertSecondsToTime(data.fullCallDuration) : data.fullCallDuration === 0 ? '00:00:00' : '- - -'}
                            style={{cursor: 'pointer'}}
                        />
                        <Column
                            header={'Тривалість розмови'}
                            className="justify-content-start"
                            body={(data) => data.duration && data.duration !== -1 ? convertSecondsToTime(data.duration) : data.duration === 0 ? '00:00:00' : '- - -'}
                            style={{cursor: 'pointer'}}
                        />
                        <Column
                            header={'Реакція Клієнта'}
                            className="justify-content-start"
                            body={(data) => data.reactionClient && data.reactionClient !== -1 ? convertSecondsToTime(data.reactionClient) : data.reactionClient === 0 ? '00:00:00' : '- - -'}
                            style={{cursor: 'pointer'}}
                        />
                        <Column
                            header={'Реакція Оператора'}
                            className="justify-content-start"
                            body={(data) => data.reactionOperator && data.reactionOperator !== -1 ? convertSecondsToTime(data.reactionOperator) : data.reactionOperator === 0 ? '00:00:00' : '- - -'}
                            style={{cursor: 'pointer'}}
                        />
                        <Column
                            header={'Початок'}
                            className="justify-content-start"
                            body={(data) => data.start ? formatDateTime(data.start) : '- - -'}
                            style={{cursor: 'pointer'}}
                        />
                        <Column
                            header={'Завершення'}
                            className="justify-content-start"
                            body={(data) => data.end ? formatDateTime(data.end) : '- - -'}
                            style={{cursor: 'pointer'}}
                        />
                        <Column
                            header={'Завершив'}
                            className="justify-content-start"
                            body={() => foundCallReset?.[0]?.name || '- - -'}
                            style={{cursor: 'pointer'}}
                        />
                        <Column
                            header={'Причина завершення'}
                            className="justify-content-start"
                            body={() => foundAmdHangup?.[0]?.name || '- - -'}
                            style={{cursor: 'pointer'}}
                        />
                        <Column
                            header={'Запис дзвінка'}
                            className="justify-content-start"
                            body={audioBodyTemplate}
                            style={{cursor: 'pointer'}}
                        />
                    </DataTable>
                </React.Fragment>}
                {windowWidth <= 1248 && (
                    <React.Fragment>
                        <div className="field col-12 md:col-5 flex align-items-center m-0">
                            <p>Клiент</p>
                        </div>
                        <div className="field col-12 md:col-5 flex align-items-center m-0">
                            <p>{monitoringData.ani || monitoringData?.aNI}</p>
                        </div>
                        <div className="field col-12 md:col-5 flex align-items-center m-0">
                            <p>Дія</p>
                        </div>
                        <div className="field col-12 md:col-7 flex align-items-center m-0">
                            <Button icon="pi pi-phone" className="status-success border-none max-w-9rem mr-2" style={{borderRadius: '6px'}} onClick={() => {
                                checkBanUser();
                            }}></Button>
                            {hasSpyVisionPermission && <Button disabled={spyHeadphonesDisabled} loading={spyListenRequestPending} icon="pi pi-headphones" className="status-success border-none max-w-9rem mr-2" style={{background: 'rgb(253, 166, 16)'}} onClick={() => {
                                checkSpySession("spy");
                            }}></Button>}
                        </div>
                        <div className="field col-12 md:col-5 flex align-items-center m-0">
                            <p>Власник дзвінка</p>
                        </div>
                        <div className="field col-12 md:col-5 flex align-items-center m-0">
                            <p>{monitoringData.ownerUserName || '- - -'}</p>
                        </div>
                        <div className="field col-12 md:col-5 flex align-items-center m-0">
                            <p>Тип власника</p>
                        </div>
                        <div className="field col-12 md:col-5 flex align-items-center m-0">
                            <p>{foundOwnerType?.[0]?.description || '- - -'}</p>
                        </div>
                        {fields.map((field: any) => (
                            <React.Fragment key={field.label}>
                                <div className="field col-12 md:col-5 flex align-items-center m-0">
                                    <p>{field.label}</p>
                                </div>
                                <div className="field col-12 md:col-7 flex align-items-center m-0">
                                    <p>{field.value}</p>
                                </div>
                            </React.Fragment>
                        ))}
                        <Divider className="m-0 py-3"/>
                        {hasPlayerVisiblePermission ? <>{!audioUrl && (
                            <div className="field col-12 md:col-12 flex align-items-center justify-content-center">
                                <Button disabled={monitoringData?.status === 101 || monitoringData?.status === 102} className="mt-3 flex align-items-center" loading={audioUrlLoading || loader}
                                        onClick={() => handlePlay()}><p className="pl-1 m-0">Прослухати запис дзвінка</p>
                                </Button>
                            </div>)}
                            {audioUrl && (<div
                                className={`field col-12 md:col-12 flex flex-column align-items-center relative absolute outline-none border-none shadow-none border-circle save-mp3 text-lg mt-3 px-0 ${(!audioUrl || loader) && 'opacity-40'}`}>
                                <Dropdown disabled={loader || !isDropdownEnabled} filter value={isSpeakingAudio} onChange={(e) => dispatch(setIsSpeacking(e.value))} options={audioOptions} optionLabel="name"
                                          className="w-full mt-2 mb-3"/>
                                {hasPlayerUpdatePermission && <Button
                                    onClick={() => dispatch(uploadTempUrl(jwtToken?.jwtToken, monitoringData?.sessionId, monitoringData?.id, isSpeakingAudio))}
                                    disabled={!validAudioUrl || loader} icon="pi pi-download"
                                    loading={audioUrlUploadLoading}
                                    className={`absolute outline-none border-none shadow-none border-circle save-mp3 text-lg ${audioUrl ? 'opacity-100' : 'opacity-50'}`}
                                />}
                                <div className="w-full">
                                    {loader && (
                                        <>
                                            <div className="absolute left-20 right-0 top-0 bottom-0 inset-0 flex justify-center items-center bg-opacity-50 z-100000">
                                                <Skeleton width="100%" height="100%" className="absolute inset-0"/>
                                            </div>
                                            <ProgressBar className="absolute w-full" mode="indeterminate" style={{height: '3px'}}></ProgressBar>
                                        </>
                                    )}
                                    <AudioPlayer audioUrl={validAudioUrl} handleResetPlayer={props.handleResetPlayer} timeStamp={timeStamp}
                                                 setTimeStamp={setTimeStamp}/>
                                </div>
                            </div>)}
                        </> : ''}
                    </React.Fragment>
                )}
            </div>
        </div>
    );
};

export default MonitoringListDetails;
